import React, { useState, useEffect } from 'react';
import './App.css';
import Main from './homePage/Main';
import About from './AboutPage/About';
import Projects from './ProjectsPage/Projects';
import Contact from './ContactPage/Contact'
import PostPage from './Blog/PostPage/PostPage'
import NotFound from './homePage/NotFound';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import BlueSky from './Static/bluesky-custom.png';
import TikTok from './Static/tiktok-custom.png';
import Instagram from './Static/IG_Glyph_Fill.png';
import Twitter from './Static/Twitter_Logo_WhiteOnImage.png';


function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowWidth, setWindowWidth] = useState({
    width: undefined
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
    setWindowWidth(window.innerWidth);
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowWidth;
}

function App() {
  const windowWidth = useWindowSize();
  return (
    <Router>
      <div className='App-background'>
          <Routes>
            <Route path="/" exact element={<Main windowWidth={windowWidth} />}/>
            <Route path="/About" element={<About />}/>
            <Route path="/Projects" element={<Projects windowWidth={windowWidth} />}/>
            <Route path="/ContactUs" element={<Contact />}/>
            <Route path="/:id" element={<PostPage />}/>
            <Route path="*" element={<NotFound />}/>
          </Routes>
      <br/>
      <div className="App-Social">
        <Button>
          <Tooltip title="Follow us on BlueSky">
            <a href="https://bsky.app/profile/cosmictonic.bsky.social" target="_blank" rel="noopener noreferrer"><img className="Social-Logo" src={BlueSky} alt="logo"/></a>
          </Tooltip>
        </Button>
        <Button>
          <Tooltip title="Follow us on Twitter">
            <a href="https://twitter.com/cosmic_tonic" target="_blank" rel="noopener noreferrer"><img className="Social-Logo" src={Twitter} alt="logo"/></a>
          </Tooltip>
        </Button>
        <Button>
          <Tooltip title="Find us on Tik Tok">
            <a href="https://www.tiktok.com/@cosmic_tonic" target="_blank" rel="noopener noreferrer"><img className="Social-Logo" src={TikTok} alt="logo"/></a>
          </Tooltip>
        </Button>
        <Button>
          <Tooltip title="Follow us on Instagram">
            <a href="https://www.instagram.com/cosmictonicgames/" target="_blank" rel="noopener noreferrer"><img className="Social-Logo" src={Instagram} alt="logo"/></a>
          </Tooltip>
        </Button>

      </div>
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px"}}>
          
            <a href="https://cosmictonicgames.blogspot.com/feeds/posts/default"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#f26522",
              color: "white",
              padding: "8px 16px",
              borderRadius: "6px",
              textDecoration: "none",
              fontFamily: "sans-serif",
              fontWeight: "bold",
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white">
              <circle cx="6.18" cy="17.82" r="2.18" />
              <path d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z" />
            </svg>
            RSS Feed
          </a>
        </div>
      </div>
    </Router>
  );
}

export default App;
